import type {JsonMapperGlobalOptions} from "./JsonMapperGlobalOptions.js";

export const JsonMapperSettings: JsonMapperGlobalOptions = {
  disableUnsecureConstructor: true,
  additionalProperties: false,
  strictGroups: false
};
